// ***** Email Inbox Saga *****
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  EMAIL_INBOUND_GET_LIST,
  EMAIL_OUTBOUND_SEND_EMAIL,
  EMAIL_INBOUND_GET_SINGLE,
  EMAIL_INBOUND_ARCHIVE,
  EMAIL_INBOUND_MASS_MARKED_READ,
  EMAIL_INBOUND_UPDATE_STAFF,
  EMAIL_OUTBOUND_ACCOUNT_LIST,
  EMAIL_INBOUND_ARCHIVE_LIST,
  EMAIL_INBOUND_UNARCHIVE,
  EMAIL_INBOUND_MARK_AS_UNREAD,
  EMAIL_ACCOUNT_LIST,
  EMAIL_ACCOUNT_DETAILS,
  EMAIL_ACCOUNT_CREATE,
  EMAIL_ACCOUNT_UPDATE,
  EMAIL_ACCOUNT_DELETE,
  JOB_EMAIL_INBOUND_SEARCH,
  LINK_JOB_TO_EMAIL,
  EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK,
  EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS,
  EMAIL_TEMPLATE_LIST,
  EMAIL_TEMPLATE_SEARCH,
  EMAIL_TEMPLATE_DATA,
  EMAIL_TEMPLATE_CREATE,
  EMAIL_TEMPLATE_UPDATE,
  EMAIL_TEMPLATE_DELETE,
  EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED,
  EMAIL_DOMAIN_LIST,
  EMAIL_DOMAIN_DATA,
  EMAIL_DOMAIN_CREATE,
  EMAIL_DOMAIN_CHECK_DNS,
  EMAIL_DOMAIN_DELETE,
  EMAIL_INBOUND_REPLY_AUTOGENERATE,
  EMAIL_INBOUND_RULE_LIST,
  EMAIL_INBOUND_RULE_SEARCH,
  EMAIL_INBOUND_RULE_DATA,
  EMAIL_INBOUND_RULE_CREATE,
  EMAIL_INBOUND_RULE_UPDATE,
  EMAIL_INBOUND_RULE_DELETE,
  EMAIL_INBOUND_RULE_RUN,
  EMAIL_INBOUND_RULE_ITEM_FIELD_LIST,
  SYSTEM_FUNCTION_OPERAND_LIST,
} from "./actionType";

import {
  getEmailInboundListSuccess,
  getEmailInboundListError,
  sendEmailOutboundSuccess,
  sendEmailOutboundError,
  getEmailInboundSingleError,
  getEmailInboundSingleSuccess,
  getEmailInboundArchiveSuccess,
  getEmailInboundArchiveError,
  getEmailInboundMassMarkedReadSuccess,
  getEmailInboundMassMarkedReadError,
  getEmailInboundUpdateStaffSuccess,
  getEmailInboundUpdateStaffError,
  getEmailOutboundAccountListSuccess,
  getEmailOutboundAccountListError,
  getEmailInboundArchiveListSuccess,
  getEmailInboundArchiveListError,
  getEmailInboundUnarchiveSuccess,
  getEmailInboundUnarchiveError,
  getEmailInboundMarkAsUnreadSuccess,
  getEmailInboundMarkAsUnreadError,
  getEmailAccountListSuccess,
  getEmailAccountListError,
  getEmailAccountDetailsSuccess,
  getEmailAccountDetailsError,
  createEmailAccountSuccess,
  createEmailAccountError,
  updateEmailAccountSuccess,
  updateEmailAccountError,
  deleteEmailAccountSuccess,
  deleteEmailAccountError,
  jobEmailInboundSearchSuccess,
  jobEmailInboundSearchError,
  linkJobToEmailSuccess,
  linkJobToEmailError,
  emailOutboundSearchAddressBookSuccess,
  emailOutboundSearchAddressBookError,
  emailOutboundSearchAvailableAttachmentsSuccess,
  emailOutboundSearchAvailableAttachmentsError,
  emailTemplateListSuccess,
  emailTemplateListError,
  emailTemplateSearchSuccess,
  emailTemplateSearchError,
  emailTemplateDataSuccess,
  emailTemplateDataError,
  createEmailTemplateSuccess,
  createEmailTemplateError,
  updateEmailTemplateSuccess,
  updateEmailTemplateError,
  deleteEmailTemplateSuccess,
  deleteEmailTemplateError,
  sendEmailOutboundScheduledSuccess,
  sendEmailOutboundScheduledError,
  emailDomainListSuccess,
  emailDomainListError,
  emailDomainDataSuccess,
  emailDomainDataError,
  createEmailDomainSuccess,
  createEmailDomainError,
  checkEmailDomainDNSSuccess,
  checkEmailDomainDNSError,
  deleteEmailDomainSuccess,
  deleteEmailDomainError,
  emailInboundReplyAutogenerateSuccess,
  emailInboundReplyAutogenerateError,
  emailInboundRuleListSuccess,
  emailInboundRuleListError,
  emailInboundRuleSearchSuccess,
  emailInboundRuleSearchError,
  emailInboundRuleDataSuccess,
  emailInboundRuleDataError,
  createEmailInboundRuleSuccess,
  createEmailInboundRuleError,
  updateEmailInboundRuleSuccess,
  updateEmailInboundRuleError,
  deleteEmailInboundRuleSuccess,
  deleteEmailInboundRuleError,
  runEmailInboundRuleSuccess,
  runEmailInboundRuleError,
  emailInboundRuleItemFieldListSuccess,
  emailInboundRuleItemFieldListError,
  systemFunctionOperandListSuccess,
  systemFunctionOperandListError,
} from "./action";

import {
  getEmailInboundList,
  sendEmailOutbound,
  getEmailInboundSingleEmail,
  archiveEmailInboundMassEmails,
  markEmailInboundMassEmailsAsRead,
  emailInboundStaffUpdateApiCall,
  getEmailOutboundAccountListApiCall,
  getArchivedEmailListApiCall,
  unarchiveEmailApiCall,
  markEmailInboundAsUnreadApiCall,
  getEmailAccountListApiCall,
  getEmailAccountDetailsApiCall,
  createEmailAccountApiCall,
  updateEmailAccountApiCall,
  deleteEmailAccountApiCall,
  jobEmailInboundSearchApiCall,
  opportunityEmailInboundSearchApiCall,
  linkJobToEmailApiCall,
  emailOutboundSearchAddressBookApiCall,
  emailOutboundSearchAvailableAttachmentsApiCall,
  emailTemplateListApiCall,
  emailTemplateSearchApiCall,
  getEmailTemplateDataApiCall,
  createEmailTemplateApiCall,
  updateEmailTemplateApiCall,
  deleteEmailTemplateApiCall,
  sendEmailOutboundScheduledApiCall,
  emailDomainListApiCall,
  emailDomainDataApiCall,
  createEmailDomainApiCall,
  checkEmailDomainDNSApiCall,
  deleteEmailDomainApiCall,
  emailInboundReplyAutogenerateApiCall,
  emailInboundRuleListApiCall,
  emailInboundRuleSearchApiCall,
  getEmailInboundRuleDataApiCall,
  createEmailInboundRuleApiCall,
  updateEmailInboundRuleApiCall,
  deleteEmailInboundRuleApiCall,
  runEmailInboundRuleApiCall,
  emailInboundRuleItemFieldListApiCall,
  systemFunctionOperandListApiCall,
} from "../../helpers/fakebackend_helper";

//******************** Get Email Inbound List *********************//

function* getEmailInboundListItems() {
  try {
    const response = yield call(getEmailInboundList);
    yield put(getEmailInboundListSuccess(response));
  } catch (error) {
    yield put(getEmailInboundListError(error));
  }
}

export function* watchGetEmailInboundList() {
  yield takeEvery(EMAIL_INBOUND_GET_LIST, getEmailInboundListItems);
}
//******************** Get Email Inbound Single *********************//
function* getEmailInboundSingleItems({ payload }) {
  try {
    const response = yield call(getEmailInboundSingleEmail, payload);
    yield put(getEmailInboundSingleSuccess(response));
  } catch (error) {
    yield put(getEmailInboundSingleError(error));
  }
}

export function* watchGetEmailInboundSingle() {
  yield takeEvery(EMAIL_INBOUND_GET_SINGLE, getEmailInboundSingleItems);
}
// ********************* Archive Emails Inbound *********************//
function* archiveEmailInboundItems({ payload }) {
  try {
    const response = yield call(archiveEmailInboundMassEmails, payload);
    yield put(getEmailInboundArchiveSuccess(response));
  } catch (error) {
    yield put(getEmailInboundArchiveError(error));
  }
}

export function* watchArchiveEmailInbound() {
  yield takeEvery(EMAIL_INBOUND_ARCHIVE, archiveEmailInboundItems);
}

// ********************* Mark Mass Email Read Outbound *********************//
function* markEmailInboundMassReadItems({ payload }) {
  try {
    const response = yield call(markEmailInboundMassEmailsAsRead, payload);
    yield put(getEmailInboundMassMarkedReadSuccess(response));
  } catch (error) {
    yield put(getEmailInboundMassMarkedReadError(error));
  }
}

export function* watchMarkEmailInboundMassRead() {
  yield takeEvery(
    EMAIL_INBOUND_MASS_MARKED_READ,
    markEmailInboundMassReadItems
  );
}

//******************** Send Email Outbound email *********************//
function* sendEmailOutboundItems({ payload }) {
  try {
    const response = yield call(sendEmailOutbound, payload);
    yield put(sendEmailOutboundSuccess(response));
  } catch (error) {
    yield put(sendEmailOutboundError(error));
  }
}

export function* watchSendEmailOutbound() {
  yield takeEvery(EMAIL_OUTBOUND_SEND_EMAIL, sendEmailOutboundItems);
}

// Email Inbox Staff Assign Update api call
function* emailInboundStaffUpdateItems({ payload }) {
  try {
    const response = yield call(emailInboundStaffUpdateApiCall, payload);
    yield put(getEmailInboundUpdateStaffSuccess(response));
  } catch (error) {
    yield put(getEmailInboundUpdateStaffError(error));
  }
}

export function* watchEmailInboundStaffUpdate() {
  yield takeEvery(EMAIL_INBOUND_UPDATE_STAFF, emailInboundStaffUpdateItems);
}

// Email Outbound Account List api call
function* getEmailOutboundAccountListItems() {
  try {
    const response = yield call(getEmailOutboundAccountListApiCall);
    yield put(getEmailOutboundAccountListSuccess(response));
  } catch (error) {
    yield put(getEmailOutboundAccountListError(error));
  }
}

export function* watchGetEmailOutboundAccountList() {
  yield takeEvery(
    EMAIL_OUTBOUND_ACCOUNT_LIST,
    getEmailOutboundAccountListItems
  );
}

// Email Inbound Archive List api call
function* getEmailInboundArchiveListItems() {
  try {
    const response = yield call(getArchivedEmailListApiCall);
    yield put(getEmailInboundArchiveListSuccess(response));
  } catch (error) {
    yield put(getEmailInboundArchiveListError(error));
  }
}

export function* watchGetEmailInboundArchiveList() {
  yield takeEvery(EMAIL_INBOUND_ARCHIVE_LIST, getEmailInboundArchiveListItems);
}

// Email Inbound Unarchive api call
function* unarchiveEmailItems({ payload }) {
  try {
    const response = yield call(unarchiveEmailApiCall, payload);
    yield put(getEmailInboundUnarchiveSuccess(response));
  } catch (error) {
    yield put(getEmailInboundUnarchiveError(error));
  }
}

export function* watchGetEmailInboundUnarchive() {
  yield takeEvery(EMAIL_INBOUND_UNARCHIVE, unarchiveEmailItems);
}

// Email Inbound Mark as Unread api call
function* markEmailInboundAsUnreadItems({ payload }) {
  try {
    const response = yield call(markEmailInboundAsUnreadApiCall, payload);
    yield put(getEmailInboundMarkAsUnreadSuccess(response));
  } catch (error) {
    yield put(getEmailInboundMarkAsUnreadError(error));
  }
}

export function* watchGetEmailInboundMarkAsUnread() {
  yield takeEvery(EMAIL_INBOUND_MARK_AS_UNREAD, markEmailInboundAsUnreadItems);
}

//******************* Email Inbox Saga *********************//

// Email Account List api call
function* getEmailAccountListItems() {
  try {
    const response = yield call(getEmailAccountListApiCall);
    yield put(getEmailAccountListSuccess(response));
  } catch (error) {
    yield put(getEmailAccountListError(error));
  }
}

export function* watchGetEmailAccountList() {
  yield takeEvery(EMAIL_ACCOUNT_LIST, getEmailAccountListItems);
}

// Email Account Details api call
function* getEmailAccountDetailsItems({ payload }) {
  try {
    const response = yield call(getEmailAccountDetailsApiCall, payload);
    yield put(getEmailAccountDetailsSuccess(response));
  } catch (error) {
    yield put(getEmailAccountDetailsError(error));
  }
}

export function* watchGetEmailAccountDetails() {
  yield takeEvery(EMAIL_ACCOUNT_DETAILS, getEmailAccountDetailsItems);
}

// Create Email Account api call
function* createEmailAccountItems({ payload }) {
  try {
    const response = yield call(createEmailAccountApiCall, payload);
    yield put(createEmailAccountSuccess(response));
  } catch (error) {
    yield put(createEmailAccountError(error));
  }
}

export function* watchCreateEmailAccount() {
  yield takeEvery(EMAIL_ACCOUNT_CREATE, createEmailAccountItems);
}

// Update Email Account api call
function* updateEmailAccountItems({ payload }) {
  try {
    const response = yield call(updateEmailAccountApiCall, payload);
    yield put(updateEmailAccountSuccess(response));
  } catch (error) {
    yield put(updateEmailAccountError(error));
  }
}

export function* watchUpdateEmailAccount() {
  yield takeEvery(EMAIL_ACCOUNT_UPDATE, updateEmailAccountItems);
}

// Delete Email Account api call
function* deleteEmailAccountItems({ payload }) {
  try {
    const response = yield call(deleteEmailAccountApiCall, payload);
    yield put(deleteEmailAccountSuccess(response));
  } catch (error) {
    yield put(deleteEmailAccountError(error));
  }
}

export function* watchDeleteEmailAccount() {
  yield takeEvery(EMAIL_ACCOUNT_DELETE, deleteEmailAccountItems);
}

// Job Email Inbound Search api call
function* jobEmailInboundSearchItems({ payload }) {
  try {
    // Change #100151 - the opportunity Emails tab reuses this whole flow. Its
    // endpoint returns the same rows under its own key; they are handed on
    // under the job key the inbox already reads.
    if (payload?.[0]?.opportunity_data) {
      const response = yield call(opportunityEmailInboundSearchApiCall, payload);
      yield put(
        jobEmailInboundSearchSuccess({
          ...response,
          jobtoemailinbound_list: response?.opportunitytoemailinbound_list || [],
        })
      );
      return;
    }
    const response = yield call(jobEmailInboundSearchApiCall, payload);
    yield put(jobEmailInboundSearchSuccess(response));
  } catch (error) {
    yield put(jobEmailInboundSearchError(error));
  }
}

export function* watchJobEmailInboundSearch() {
  yield takeEvery(JOB_EMAIL_INBOUND_SEARCH, jobEmailInboundSearchItems);
}

// Link Job to Email api call
function* linkJobToEmailItems({ payload }) {
  try {
    const response = yield call(linkJobToEmailApiCall, payload);
    yield put(linkJobToEmailSuccess(response));
  } catch (error) {
    yield put(linkJobToEmailError(error));
  }
}

export function* watchLinkJobToEmail() {
  yield takeEvery(LINK_JOB_TO_EMAIL, linkJobToEmailItems);
}

// Email Outbound Search Address Book api call
function* emailOutboundSearchAddressBookItems({ payload }) {
  try {
    const response = yield call(emailOutboundSearchAddressBookApiCall, payload);
    yield put(emailOutboundSearchAddressBookSuccess(response));
  } catch (error) {
    yield put(emailOutboundSearchAddressBookError(error));
  }
}

export function* watchEmailOutboundSearchAddressBook() {
  yield takeEvery(
    EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK,
    emailOutboundSearchAddressBookItems
  );
}

// Email Outbound Search Available Attachments api call
function* emailOutboundSearchAvailableAttachmentsItems({ payload }) {
  try {
    const response = yield call(
      emailOutboundSearchAvailableAttachmentsApiCall,
      payload
    );
    yield put(emailOutboundSearchAvailableAttachmentsSuccess(response));
  } catch (error) {
    yield put(emailOutboundSearchAvailableAttachmentsError(error));
  }
}

export function* watchEmailOutboundSearchAvailableAttachments() {
  yield takeEvery(
    EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS,
    emailOutboundSearchAvailableAttachmentsItems
  );
}

// Email Template List api call
function* emailTemplateListItems() {
  try {
    const response = yield call(emailTemplateListApiCall);
    yield put(emailTemplateListSuccess(response));
  } catch (error) {
    yield put(emailTemplateListError(error));
  }
}

export function* watchEmailTemplateList() {
  yield takeEvery(EMAIL_TEMPLATE_LIST, emailTemplateListItems);
}

// Email Template Search api call
function* emailTemplateSearchItems({ payload }) {
  try {
    const response = yield call(emailTemplateSearchApiCall, payload);
    yield put(emailTemplateSearchSuccess(response));
  } catch (error) {
    yield put(emailTemplateSearchError(error));
  }
}

export function* watchEmailTemplateSearch() {
  yield takeEvery(EMAIL_TEMPLATE_SEARCH, emailTemplateSearchItems);
}

// Email Template Data api call
function* getEmailTemplateDataItems({ payload }) {
  try {
    const response = yield call(getEmailTemplateDataApiCall, payload);
    yield put(emailTemplateDataSuccess(response));
  } catch (error) {
    yield put(emailTemplateDataError(error));
  }
}

export function* watchEmailTemplateData() {
  yield takeEvery(EMAIL_TEMPLATE_DATA, getEmailTemplateDataItems);
}

// Create Email Template api call
function* createEmailTemplateItems({ payload }) {
  try {
    const response = yield call(createEmailTemplateApiCall, payload);
    yield put(createEmailTemplateSuccess(response));
  } catch (error) {
    yield put(createEmailTemplateError(error));
  }
}

export function* watchCreateEmailTemplate() {
  yield takeEvery(EMAIL_TEMPLATE_CREATE, createEmailTemplateItems);
}

// Update Email Template api call
function* updateEmailTemplateItems({ payload }) {
  try {
    const response = yield call(updateEmailTemplateApiCall, payload);
    yield put(updateEmailTemplateSuccess(response));
  } catch (error) {
    yield put(updateEmailTemplateError(error));
  }
}

export function* watchUpdateEmailTemplate() {
  yield takeEvery(EMAIL_TEMPLATE_UPDATE, updateEmailTemplateItems);
}

// Delete Email Template api call
function* deleteEmailTemplateItems({ payload }) {
  try {
    const response = yield call(deleteEmailTemplateApiCall, payload);
    yield put(deleteEmailTemplateSuccess(response));
  } catch (error) {
    yield put(deleteEmailTemplateError(error));
  }
}

export function* watchDeleteEmailTemplate() {
  yield takeEvery(EMAIL_TEMPLATE_DELETE, deleteEmailTemplateItems);
}

// Send Email Outbound Scheduled api call
function* sendEmailOutboundScheduledItems({ payload }) {
  try {
    const response = yield call(sendEmailOutboundScheduledApiCall, payload);
    yield put(sendEmailOutboundScheduledSuccess(response));
  } catch (error) {
    yield put(sendEmailOutboundScheduledError(error));
  }
}

export function* watchSendEmailOutboundScheduled() {
  yield takeEvery(
    EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED,
    sendEmailOutboundScheduledItems
  );
}

// Email Domain List api call
function* emailDomainListItems() {
  try {
    const response = yield call(emailDomainListApiCall);
    yield put(emailDomainListSuccess(response));
  } catch (error) {
    yield put(emailDomainListError(error));
  }
}

export function* watchEmailDomainList() {
  yield takeEvery(EMAIL_DOMAIN_LIST, emailDomainListItems);
}

// Email Domain Data api call
function* emailDomainDataItems({ payload }) {
  try {
    const response = yield call(emailDomainDataApiCall, payload);
    yield put(emailDomainDataSuccess(response));
  } catch (error) {
    yield put(emailDomainDataError(error));
  }
}

export function* watchEmailDomainData() {
  yield takeEvery(EMAIL_DOMAIN_DATA, emailDomainDataItems);
}

// Create Email Domain api call
function* createEmailDomainItems({ payload }) {
  try {
    const response = yield call(createEmailDomainApiCall, payload);
    yield put(createEmailDomainSuccess(response));
  } catch (error) {
    yield put(createEmailDomainError(error));
  }
}

export function* watchCreateEmailDomain() {
  yield takeEvery(EMAIL_DOMAIN_CREATE, createEmailDomainItems);
}

// Check Email Domain DNS api call
function* checkEmailDomainDNSItems({ payload }) {
  try {
    const response = yield call(checkEmailDomainDNSApiCall, payload);
    yield put(checkEmailDomainDNSSuccess(response));
  } catch (error) {
    yield put(checkEmailDomainDNSError(error));
  }
}

export function* watchCheckEmailDomainDNS() {
  yield takeEvery(EMAIL_DOMAIN_CHECK_DNS, checkEmailDomainDNSItems);
}

// Delete Email Domain api call
function* deleteEmailDomainItems({ payload }) {
  try {
    const response = yield call(deleteEmailDomainApiCall, payload);
    yield put(deleteEmailDomainSuccess(response));
  } catch (error) {
    yield put(deleteEmailDomainError(error));
  }
}

export function* watchDeleteEmailDomain() {
  yield takeEvery(EMAIL_DOMAIN_DELETE, deleteEmailDomainItems);
}

// Email Inbound Reply Autogenerate api call
function* emailInboundReplyAutogenerateItems({ payload }) {
  try {
    const response = yield call(emailInboundReplyAutogenerateApiCall, payload);
    yield put(emailInboundReplyAutogenerateSuccess(response));
  } catch (error) {
    yield put(emailInboundReplyAutogenerateError(error));
  }
}

export function* watchEmailInboundReplyAutogenerate() {
  yield takeEvery(
    EMAIL_INBOUND_REPLY_AUTOGENERATE,
    emailInboundReplyAutogenerateItems
  );
}

//******************* Email Inbound Rule *********************//

function* emailInboundRuleListItems() {
  try {
    const response = yield call(emailInboundRuleListApiCall);
    yield put(emailInboundRuleListSuccess(response));
  } catch (error) {
    yield put(emailInboundRuleListError(error));
  }
}
export function* watchEmailInboundRuleList() {
  yield takeEvery(EMAIL_INBOUND_RULE_LIST, emailInboundRuleListItems);
}

function* emailInboundRuleSearchItems({ payload }) {
  try {
    const response = yield call(emailInboundRuleSearchApiCall, payload);
    yield put(emailInboundRuleSearchSuccess(response));
  } catch (error) {
    yield put(emailInboundRuleSearchError(error));
  }
}
export function* watchEmailInboundRuleSearch() {
  yield takeEvery(EMAIL_INBOUND_RULE_SEARCH, emailInboundRuleSearchItems);
}

function* getEmailInboundRuleDataItems({ payload }) {
  try {
    const response = yield call(getEmailInboundRuleDataApiCall, payload);
    yield put(emailInboundRuleDataSuccess(response));
  } catch (error) {
    yield put(emailInboundRuleDataError(error));
  }
}
export function* watchEmailInboundRuleData() {
  yield takeEvery(EMAIL_INBOUND_RULE_DATA, getEmailInboundRuleDataItems);
}

function* createEmailInboundRuleItems({ payload }) {
  try {
    const response = yield call(createEmailInboundRuleApiCall, payload);
    yield put(createEmailInboundRuleSuccess(response));
  } catch (error) {
    yield put(createEmailInboundRuleError(error));
  }
}
export function* watchCreateEmailInboundRule() {
  yield takeEvery(EMAIL_INBOUND_RULE_CREATE, createEmailInboundRuleItems);
}

function* updateEmailInboundRuleItems({ payload }) {
  try {
    const response = yield call(updateEmailInboundRuleApiCall, payload);
    yield put(updateEmailInboundRuleSuccess(response));
  } catch (error) {
    yield put(updateEmailInboundRuleError(error));
  }
}
export function* watchUpdateEmailInboundRule() {
  yield takeEvery(EMAIL_INBOUND_RULE_UPDATE, updateEmailInboundRuleItems);
}

function* deleteEmailInboundRuleItems({ payload }) {
  try {
    const response = yield call(deleteEmailInboundRuleApiCall, payload);
    yield put(deleteEmailInboundRuleSuccess(response));
  } catch (error) {
    yield put(deleteEmailInboundRuleError(error));
  }
}
export function* watchDeleteEmailInboundRule() {
  yield takeEvery(EMAIL_INBOUND_RULE_DELETE, deleteEmailInboundRuleItems);
}

function* runEmailInboundRuleItems({ payload }) {
  try {
    const response = yield call(runEmailInboundRuleApiCall, payload);
    yield put(runEmailInboundRuleSuccess(response));
  } catch (error) {
    yield put(runEmailInboundRuleError(error));
  }
}
export function* watchRunEmailInboundRule() {
  yield takeEvery(EMAIL_INBOUND_RULE_RUN, runEmailInboundRuleItems);
}

function* emailInboundRuleItemFieldListItems() {
  try {
    const response = yield call(emailInboundRuleItemFieldListApiCall);
    yield put(emailInboundRuleItemFieldListSuccess(response));
  } catch (error) {
    yield put(emailInboundRuleItemFieldListError(error));
  }
}
export function* watchEmailInboundRuleItemFieldList() {
  yield takeEvery(
    EMAIL_INBOUND_RULE_ITEM_FIELD_LIST,
    emailInboundRuleItemFieldListItems
  );
}

function* systemFunctionOperandListItems() {
  try {
    const response = yield call(systemFunctionOperandListApiCall);
    yield put(systemFunctionOperandListSuccess(response));
  } catch (error) {
    yield put(systemFunctionOperandListError(error));
  }
}
export function* watchSystemFunctionOperandList() {
  yield takeEvery(SYSTEM_FUNCTION_OPERAND_LIST, systemFunctionOperandListItems);
}

//******************* Email Inbox Saga *********************//

function* EmailInboxSaga() {
  yield all([
    fork(watchGetEmailInboundList),
    fork(watchSendEmailOutbound),
    fork(watchGetEmailInboundSingle),
    fork(watchArchiveEmailInbound),
    fork(watchMarkEmailInboundMassRead),
    fork(watchEmailInboundStaffUpdate),
    fork(watchGetEmailOutboundAccountList),
    fork(watchGetEmailInboundArchiveList),
    fork(watchGetEmailInboundUnarchive),
    fork(watchGetEmailInboundMarkAsUnread),
    fork(watchGetEmailAccountList),
    fork(watchGetEmailAccountDetails),
    fork(watchCreateEmailAccount),
    fork(watchUpdateEmailAccount),
    fork(watchDeleteEmailAccount),
    fork(watchJobEmailInboundSearch),
    fork(watchLinkJobToEmail),
    fork(watchEmailOutboundSearchAddressBook),
    fork(watchEmailOutboundSearchAvailableAttachments),
    fork(watchEmailTemplateList),
    fork(watchEmailTemplateSearch),
    fork(watchEmailTemplateData),
    fork(watchCreateEmailTemplate),
    fork(watchUpdateEmailTemplate),
    fork(watchDeleteEmailTemplate),
    fork(watchSendEmailOutboundScheduled),
    fork(watchEmailDomainList),
    fork(watchEmailDomainData),
    fork(watchCreateEmailDomain),
    fork(watchCheckEmailDomainDNS),
    fork(watchDeleteEmailDomain),
    fork(watchEmailInboundReplyAutogenerate),
    fork(watchEmailInboundRuleList),
    fork(watchEmailInboundRuleSearch),
    fork(watchEmailInboundRuleData),
    fork(watchCreateEmailInboundRule),
    fork(watchUpdateEmailInboundRule),
    fork(watchDeleteEmailInboundRule),
    fork(watchRunEmailInboundRule),
    fork(watchEmailInboundRuleItemFieldList),
    fork(watchSystemFunctionOperandList),
  ]);
}

export default EmailInboxSaga;
